<template>
    <div class="contatti">
      <h2>CONTATTI</h2>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1188.307391467221!2d11.08113073659613!3d44.897152779847936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477f976eb0f20093%3A0x62b0e25193b2b9cd!2sTecnoservice%20snc!5e0!3m2!1sen!2sit!4v1768667230725!5m2!1sen!2sit" width="100%" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      <div class="sections">
        <div class="richieste">
          <h3 class="titolo-sezione">RICHIESTE</h3>
          <p>Per qualsiasi richiesta o domanda chiama il numero +39.0535.25202 o compila il seguente modulo:</p>
          <h3 class="titolo-sezione">CONTATTACI</h3>
          <form class="contact-form" @submit.prevent="sendEmail">
    
            <div class="form-group">
              <label>Nome</label>
              <input type="text" v-model="form.nome" required />
            </div>

            <div class="form-group">
              <label>Cognome</label>
              <input type="text" v-model="form.cognome" required />
            </div>

            <div class="form-group">
              <label>Email</label>
              <input type="email" v-model="form.email" required />
            </div>

            <div class="form-group">
              <label>Oggetto</label>
              <input type="text" v-model="form.oggetto" />
            </div>

            <div class="form-group">
              <label>Messaggio</label>
              <textarea v-model="form.messaggio" required></textarea>
            </div>

            <div class="form-actions">
              <button type="submit">INVIA</button>
            </div>

          </form>
        </div>
        <div class="colonnadestra">
          <div class="sezione-top">
            <div class="direzione">
              <h3 class="titolo-sezione">DIREZIONE</h3>
              <address>Via 1° Gennaio 1948, 3/5 Mirandola</address>
              <div class="links">
                <a href="tel:+39053525202">TEL: 0535.25202</a>
                <a href="mailto:info@tcan.it">MAIL: info@tcan.it</a>
              </div>
            </div>
            <div class="lavora">
              <h3 CLASS="titolo-sezione">LAVORA CON NOI</h3>
              <p>Per candidarti per un lavoro presso Tecnoservice, invia una lettera di presentazione insieme al tuo C.V. a:
                <a href="mailto:info@tcan.it">info@tcan.it</a>
              </p>
            </div>
          </div>
          <div class="info">
            <a href="tel:+39053525202">INFORMAZIONI: 0535.25202</a>
          </div>
        </div>
      </div>
    </div>
</template>


<script>
import emailjs from 'emailjs-com'

export default {
  name: 'ConTatti',
  data() {
    return {
      form: {
        nome: '',
        cognome: '',
        email: '',
        oggetto: '',
        messaggio: ''
      }
    }
  },
  methods: {
    sendEmail() {
      emailjs.send(
        'service_rwkh4ok',
        'template_ny350il',
        this.form,
        'jLnmBQmyuHYfWvbt1'
      )
      .then(() => {
        alert('Messaggio inviato!')
        this.form = {
          nome: '',
          cognome: '',
          email: '',
          oggetto: '',
          messaggio: ''
        }
      })
      .catch((error) => {
        console.error('EMAILJS ERROR:', error)
        alert('Errore invio messaggio')
      })
    }
  }
}
    
</script>

<style lang="scss" scoped>

  .contatti {
    min-height: 100vh;
    width: 100vw;
    padding: 0 5vw;

    h2 {
      font-size: 2.3rem;
      margin: 4vh;
      
      &::after {
      //Tutto questo codice serve a creare la barra verde al di sotto della scritta "Applicazioni"
      content: "";
      display: block;
      background-color: $tcan_green;
      margin: 1vh auto 0;
      width: 7vw;
      height: 5px;
    }
    }
  }

  //Questo è il codice per il contenitore delle sezioni sotto la mappa
  .sections {
    margin-top: 10vh;
    margin-bottom: 20vh;
    display: grid;
    grid-template-columns: 40% 50%; // sinistra + destra 
    gap: 10%; // spazio tra le colonne
    text-align: left;
    p {
      font-size: 1.1rem;
    }
  }



  //Form di richieste

  .titolo-sezione {
    font-size: 2rem;
    margin: 5vh 0;
  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 3vh;
    max-width: 45vw;
  }

  /* gruppo input */
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.8vh;

    label {
      font-size: 1rem;
      font-weight: 600;
      color: #333;
    }

    input,
    textarea {
      background-color: #eaeaea;
      border: none;
      padding: 12px 14px;
      font-size: 1rem;
      font-family: inherit;
      resize: none;

      &:focus {
        outline: none;
        background-color: #dedede;
      }
    }

    textarea {
      min-height: 160px;
    }
  }

  /* pulsante */
  .form-actions {
    display: flex;
    justify-content: flex-end;

    button {
      border: none;
      padding: 12px 28px;
      font-size: 0.95rem;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.3s ease;
      color: white;
      background-color: $tcan_green;

      &:hover {
        background-color: darken($tcan_green, 10%);
      }
    }
  }

  .colonnadestra {
      display: flex;
      flex-direction: column;
      gap: 2vh;
  }
  .direzione {
    font-size: 1.3rem;
    .links {
      margin-top: 2vh;
      display: flex;
      flex-direction: column;
      
      a {
        text-decoration: none;
        color: black;
      }
    }
  }

  .lavora {
    a {
      text-decoration: none;
      color: black;
      display: block;
      margin-top: 2vh;
    }
  }

  .info {
    font-size: 2rem;
    font-weight: bolder;
    a {
      text-decoration: none;
      color: black;
      &::before {
        content: "";
        display: block;
        width: 10vw;
        height: 8px;
        background-color: $tcan_orange;
      }
    }
  }

  .sezione-top {
    margin-bottom: auto;
  }

  @media screen and (max-width: 768px) {

    iframe {
      height: 40vh;
    }

    .sections {
      display: contents;
    }

    .contact-form {
      max-width: 90vw;
    }

    .info {
      margin-top: 3vh;
    }
    
  }
</style>
